import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
export function FiltersIcon(props) {
    const themeContext = useContext(ThemeContext);
    const { color = 'TextSubtleGrey', ...rest } = props;
    const primaryFillColor = themeContext.colors[color];
    return (_jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...rest, children: _jsx("path", { d: "M6.32 11.5V3M6.32 20v-2.318M8.636 14.59H4v3.092h4.636V14.59zM12.5 3.773V3M12.5 20V9.955M14.816 6.864H10.18v3.09h4.636v-3.09zM18.68 11.5V3M18.68 20v-2.318M21.001 14.59h-4.636v3.091H21v-3.09z", stroke: primaryFillColor, strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}
//# sourceMappingURL=Filters.js.map